import initData from 'init-data';

const isEnabled = key => {
    return (
        initData && initData.featureSwitches && initData.featureSwitches[key]
    );
};

export const errors = {
    ELASTIC_MYTRADERA:
        'Just nu har vi driftstörningar på delar av Mitt Tradera. Vi arbetar på att lösa problemet.'
};

export default {
    isDisputesEntranceEnabled: isEnabled('disputes-entrance'),
    isMyTraderaElasticEnabled: isEnabled('mytradera-elasticsearch'),
    isBuyerOrderInformationEnabled: isEnabled('buyer-order-information'),
    isMessagingEnabled: isEnabled('messaging'),
    isMessagingBuyerButtonsEnabled: isEnabled(
        'messaging-contact-buyer-buttons'
    ),
    isMessagingSellerButtonsEnabled: isEnabled(
        'messaging-contact-seller-buttons'
    )
};
